import { render, staticRenderFns } from "./ProcessProAccept.vue?vue&type=template&id=703d64f6&scoped=true"
import script from "./ProcessProAccept.vue?vue&type=script&lang=js"
export * from "./ProcessProAccept.vue?vue&type=script&lang=js"
import style0 from "./ProcessProAccept.vue?vue&type=style&index=0&id=703d64f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d64f6",
  null
  
)

export default component.exports